import type { SuggestionType } from "@/types/suggestions";

/** Leaf module: query keys only, no runtime imports, so any consumer can read them for free. */
export const suggestionQueryKeys = {
  all: ["suggestions"] as const,
  list: (
    suggestionTypes: SuggestionType[],
    patientId?: string,
    eventId?: string,
    scope?: {
      providerId?: string;
      noteTemplateId?: string;
      noteQuestionId?: string;
    },
  ) =>
    [
      ...suggestionQueryKeys.all,
      suggestionTypes,
      patientId,
      eventId,
      scope,
    ] as const,
  personal: ["personal-suggestions"] as const,
};
